import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-surface border-t border-border py-12 px-4 sm:px-6 lg:px-8" data-id="element-25">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-26">
        <div className="flex items-center" data-id="element-27">
          <Link to="/" data-id="element-28">
            <img src="https://assets.cru.io/cru-logo-primary.png" alt="CRU" className="h-12 hover:opacity-80 transition-opacity" data-id="element-29" />
          </Link>
        </div>

        <nav className="flex flex-wrap justify-center gap-8" data-id="element-30">
          <Link to="/modern-commerce" className="text-text hover:text-primary transition-colors font-medium" data-id="element-31">
            Modern Commerce
          </Link>
          <Link to="/apps-division" className="text-text hover:text-primary transition-colors font-medium" data-id="element-32">
            Apps Division
          </Link>
          <Link to="/about" className="text-text hover:text-primary transition-colors font-medium" data-id="element-33">
            About
          </Link>
          <Link to="/careers" className="text-text hover:text-primary transition-colors font-medium" data-id="element-34">
            Careers
          </Link>
          <Link to="/contact" className="text-text hover:text-primary transition-colors font-medium" data-id="element-35">
            Contact
          </Link>
        </nav>

        <div className="text-muted text-sm" data-id="element-36">© 2026 CRU.io Pty Ltd</div>
      </div>
    </footer>;
}